<template>
  <div class="nx-searcher-saved-searches-wrapper">
    <v-menu v-model="openSearchesMenu">
      <template v-slot:activator="{on}">
        <v-btn icon color="primary" flat v-on="on">
          <v-icon>filter_list</v-icon>
        </v-btn>
      </template>
      <v-list dense style="max-height: 75vh">
        <v-list-tile
          v-for="(action, index) in searchActions"
          :key="index"
          @click="openDialog(action.dialog)"
        >
          <v-list-tile-avatar>
            <v-icon>{{ action.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>{{ action.title }}</v-list-tile-title>
        </v-list-tile>

        <v-divider></v-divider>

        <nx-saved-searches-menu-list
          :show-only-searches-for-entity="showOnlyCurrentEntity ? entity : undefined"
          show-empty-message
          @input="applySearchFilters($event)"
        />

      </v-list>
    </v-menu>
    <nx-saved-searches-manage-dialog
      v-if="dialogState.manage.render"
      :value="dialogState.manage.active"
      @input:dialog="closeDialog('manage')"
    />
    <nx-saved-searches-create-dialog
      v-if="dialogState.create.render"
      :value="dialogState.create.active"
      @input:dialog="closeDialog('create')"
      :entity="entity" :sort="sort" :filters="filters"
    />
  </div>
</template>

<script>
import NxSavedSearchesMenuList from '@/modules/saved-searches/components/SavedSearchesMenuList.vue';
import NxSavedSearchesManageDialog from '@/modules/saved-searches/components/SavedSearchesManageDialog.vue';
import NxSavedSearchesCreateDialog from '@/modules/saved-searches/components/SavedSearchesCreateDialog.vue';
import ManageDialogs, { initDialog } from '@/mixins/manage-dialogs';

/**
 * @description Este componente se encarga de mostrar el desplegable de
 * las búsquedas y dos botones: 'Guardar búsqueda' y 'Organizar búsquedas guardads`
 * así como el listado de búsquedas.
 *
 *
 * El botón de 'Organizar búsquedas guardadas' abre un modal con un listado
 * --------------------------------------------------------------
 * Nombre de la búsqueda         botón de editar + botón eliminar
 * --------------------------------------------------------------
 *
 * El botón de editar habilita un text-field con el que modificar el valor
 * del nombre de la búsqueda. Sólo se guardan las búsquedas cuando se interactua
 * con el botón "LISTO", ahí se itera cada elemento para generar un diff sobre el cual
 * se llamará a la API para guardar esa búsqueda
 *
 * @emits load-saved-searches
 * se lanza cuando hacemos click sobre alguna de las búsquedas
 */
export default {
  name: 'nx-searcher-saved-searches',
  mixins: [ManageDialogs],
  components: {
    NxSavedSearchesCreateDialog,
    NxSavedSearchesManageDialog,
    NxSavedSearchesMenuList,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    sort: {
      type: Object,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
    showOnlyCurrentEntity: Boolean,
  },
  data() {
    return {
      openSearchesMenu: false,
      // Las acciones disponibles en el botón de la barra buscadora
      searchActions: [
        {
          icon: 'save',
          title: this.$t('message.searcher.savedSearch.saveNewSearch'),
          dialog: 'create',
        },
        {
          icon: 'edit',
          title: this.$t('message.searcher.savedSearch.editSearches'),
          dialog: 'manage',
        },
      ],
      // Guarda el estado de cada diálogo: `render` para pintar el componente, y `active` para abrir el diálogo.
      dialogState: {
        manage: initDialog(),
        create: initDialog(),
      },
    };
  },
  methods: {
    applySearchFilters(search) {
      this.$emit('load-saved-search', {
        entity: search.searcher,
        filters: search.filters,
        sort: search.sort || null,
      });
    },
  },
};
</script>
